import React, {Component} from 'react';
import {Modal, ModalHeader} from "reactstrap";
import AddNoteForm from "./AddNoteForm";
import {FaIcon} from "../../../FaIcon";
import { withTranslation } from 'react-i18next';

class AddNoteModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };
        this.toggle = this.toggle.bind(this);
        this.handleFormSubmitted = this.handleFormSubmitted.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    handleFormSubmitted(amount) {
        this.toggle();
        this.props.onSubmit(amount);
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <button className="add-note-button" onClick={this.toggle}>+</button>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader><FaIcon iconName="envelope"/>{t('add_note_title')}</ModalHeader>
                    <AddNoteForm leadId={this.props.leadId} onSubmit={this.handleFormSubmitted}/>
                </Modal>
            </div>
        );
    }
}

export default withTranslation()(AddNoteModal);
